const ClientHandlingErrorStatusCode = -1;
const DefaultErrorStatusCode = "default";
var ClientHandlingErrorReason = /*#__PURE__*/ function(ClientHandlingErrorReason) {
    ClientHandlingErrorReason[ClientHandlingErrorReason["Abort"] = -1] = "Abort";
    ClientHandlingErrorReason[ClientHandlingErrorReason["Timeout"] = -2] = "Timeout";
    ClientHandlingErrorReason[ClientHandlingErrorReason["Network"] = -3] = "Network";
    ClientHandlingErrorReason[ClientHandlingErrorReason["ParseError"] = -4] = "ParseError";
    ClientHandlingErrorReason[ClientHandlingErrorReason["RetryLimitReached"] = -5] = "RetryLimitReached";
    return ClientHandlingErrorReason;
}(ClientHandlingErrorReason || {});
export { ClientHandlingErrorStatusCode, ClientHandlingErrorReason, DefaultErrorStatusCode };
